import classNames from "classnames"
import React, { useContext } from "react"

import { Color } from "../../../constants/V2/color"
import PillButton from "../../elements/V2/Buttons/PillButton"
import StickyContainer from "../../elements/V2/StickyContainer"
import { NavigationV2Context } from "../Navigation/context"

import AddToCartButton from "@components/elements/V2/Buttons/AddToCartButton"
import { Experiment } from "@constants/experiments"
import { useIsExperiment } from "@hooks/experiments"
import { usePageLayoutState } from "@utils/layout"

type Props = {
  className?: string
  primaryButtonText?: string
  primaryButtonLink?: string
  primaryButtonMobileLink?: string
  primaryButtonColor?: Color
  isCtaVisible?: boolean
  children: React.ReactNode
} & Partial<Storyblok.CTATrackingEvent>

const HeroLayout = ({
  className,
  primaryButtonText,
  primaryButtonLink,
  primaryButtonMobileLink,
  primaryButtonColor = Color.Blue,
  trackingEvent,
  trackingEventKey,
  trackingEventValue,
  children,
}: Props) => {
  const navigationContext = useContext(NavigationV2Context)
  const isProductHeroExperiment = useIsExperiment(Experiment.PRODUCT_HERO_CTA)

  const {
    heroCTAPurchasableItem,
    hasSiteBanner,
    hasAnchorNavigation: hasNavigationBar,
    heroCTAVisible,
  } = usePageLayoutState()

  return (
    <>
      <div
        className={classNames(
          "pb-lg -mb-lg -order-1 md:-order-2",
          className,
          hasNavigationBar
            ? hasSiteBanner
              ? "md:max-h-[90dvh] lg:max-h-[88dvh] xl:max-h-[91dvh]"
              : "md:max-h-[95dvh] lg:max-h-[95dvh] xl:max-h-[95dvh]" //NO site banner
            : ""
        )}
      >
        {children}
      </div>

      <StickyContainer
        isVisible={
          typeof heroCTAVisible === "boolean" &&
          !heroCTAVisible &&
          !navigationContext.isMobileMenuOpen
        }
      >
        {heroCTAPurchasableItem && !isProductHeroExperiment ? (
          <AddToCartButton
            size="large"
            style="solid"
            purchasableItem={heroCTAPurchasableItem}
            buttonColor={primaryButtonColor}
          />
        ) : primaryButtonText && primaryButtonLink ? (
          <PillButton
            size="large"
            style="solid"
            text={primaryButtonText}
            color={primaryButtonColor}
            linkUrl={primaryButtonLink}
            mobileLinkUrl={primaryButtonMobileLink}
            trackingEvent={trackingEvent}
            trackingEventKey={trackingEventKey}
            trackingEventValue={trackingEventValue}
          />
        ) : null}
      </StickyContainer>
    </>
  )
}

export default HeroLayout
